import { RADIUS } from "./card";
import { C } from "./tokens";

const SECTION_SKELETON_CSS = `
  .sec-skel { opacity: 0; animation: secSkelIn 220ms ease 140ms forwards; }
  .sec-skel-block {
    border-radius: ${RADIUS.xl}px;
    border: 1px solid ${C.border};
    background: ${C.mute};
  }
  .sec-skel-line { border-radius: 6px; background: ${C.muteStrong}; }
  .sec-skel-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 16px; }
  @keyframes secSkelIn { to { opacity: 1; } }
  @keyframes secSkelPulse { 0%, 100% { opacity: 0.55; } 50% { opacity: 1; } }
  @media (prefers-reduced-motion: no-preference) {
    .sec-skel-block, .sec-skel-line { animation: secSkelPulse 2.4s ease-in-out infinite; }
  }
  @media (prefers-reduced-motion: reduce) {
    .sec-skel { opacity: 1; animation: none; }
  }
  @media (max-width: 720px) {
    .sec-skel-row { grid-template-columns: 1fr; }
  }
`;

export function SectionSkeleton({ minHeight = "60vh" }: { minHeight?: string }) {
  return (
    <div className="sec-skel" style={{ minHeight }} aria-busy="true" aria-label="Loading section">
      <style>{SECTION_SKELETON_CSS}</style>
      <div className="sec-skel-line" style={{ width: 132, height: 10 }} />
      <div className="sec-skel-line" style={{ width: "42%", height: 30, marginTop: 18 }} />
      <div className="sec-skel-line" style={{ width: "56%", height: 12, marginTop: 14 }} />
      <div className="sec-skel-block" style={{ height: 176, marginTop: 28 }} />
      <div className="sec-skel-row">
        <div className="sec-skel-block" style={{ height: 220 }} />
        <div className="sec-skel-block" style={{ height: 220 }} />
      </div>
    </div>
  );
}
